@use "variables" as *;

.description {
  font-size: $fontSize-xs;
  font-weight: normal;
  padding: $spacing-s;
  text-align: left;
  overflow: auto;
}

.points {
  width: 40px;
  height: 40px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: $fontSize-xl;
  font-weight: bold;
  border-radius: 50%;
}
